import { Service } from '@roc/feature-app-core';
import { URLSearchParams } from 'url';


const url = {
  CHOOSE_FUNDING_PREFERENCE:
    '/api/v1/document/formDocument/updateLoanFundingPreference',
  RECALCULATE_LENDER_FEE: '/nportal/rest/priv/loanDocs/recalculateAttorneyFee'
};

export class FundingPreferenceService extends Service {
  updateFundingPreference = (loanId: string, data) => {
    return this.post(`${url.CHOOSE_FUNDING_PREFERENCE}?loanId=${loanId}`, data);
  };

  getLenderOperatingState = (lenderId: string) => {
    return this.get(
      `/api/v1/loan/getLenderOperatingState?lenderId=${lenderId}`
    );
  };

  recalculateLenderFee = (loanId: string, data) => {
    return this.post(`${url.RECALCULATE_LENDER_FEE}?loanId=${loanId}`, data);
  };
}

// TO DO: METHOD TO GET USER ROLE.
